import React, { useContext, useEffect, useRef, useState } from "react";
import "../../assets/css/--page-aboutus.css";
import whatIsAGrocerant from "../../assets/images/whatIsAGrocerant.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import exploreImg from "../../assets/images/explore-image.jpg";
import sliderImg1 from "../../assets/images/slider1.jpg";
import sliderImg2 from "../../assets/images/slider2.png";
import sliderImg3 from "../../assets/images/slider3.png";
import sliderImg4 from "../../assets/images/slider4.jpg";


const images = [sliderImg1, sliderImg2, sliderImg3, sliderImg4, sliderImg1, sliderImg2, sliderImg3, sliderImg4];

export default function ValuesSection() {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const [swiperInitialized, setSwiperInitialized] = useState(false);

    useEffect(() => {
        setSwiperInitialized(true);
    }, []);

  return (
    <div className="intro-section">
        <div className="wrapper">
            <div className="intro-layout">
            <div className="content-section">
                    <div className="header">
                        <img src={whatIsAGrocerant} alt="Values" />
                        <h1>Not Just a Grocery.
                        <br />Not Just a Grill.</h1>
                    </div>
                    <div className="content">
                        <h2>At Main's, we like to say we're a "grocerant"—a unique blend of a small-town grocery and a fast-casual restaurant. From dawn till night, seven days a week, we're here to serve hot meals, cold drinks, everyday essentials, and a warm, familiar smile.
                        <span><br /><br />  Whether you're grabbing a breakfast sandwich before work, picking up groceries for dinner, or stopping by for our famous Fish and Chips on a Friday, we aim to make every visit feel like home. Our doors open early, close late, and only rest two days a year—Thanksgiving and Christmas—because we know how much our community counts on us.</span></h2>
                    </div>
            </div>
            </div>
        </div>

        {/* Slider outside wrapper to extend full width */}
        <div className="slider-container-full">
            <div className="slider-wrapper">
                <div className="slider">
                {swiperInitialized && (
                    <Swiper
                        modules={[Navigation]}
                        breakpoints={{
                            320: {
                                slidesPerView: 1.1
                            },
                            480: {
                                slidesPerView: 1.4
                            },
                            640: {
                                slidesPerView: 1.7
                            },
                            768: {
                                slidesPerView: 1.5
                            },
                            960: {
                                slidesPerView: 2
                            },
                            1060: {
                                slidesPerView: 2.2
                            },
                            1280: {
                                slidesPerView: 2.7
                            },
                            1440: {
                                slidesPerView: 3,
                            },
                        }}
                        slidesPerView={1}
                        loop={false}
                        navigation={{
                            prevEl: prevRef.current,
                            nextEl: nextRef.current,
                        }}
                        onInit={(swiper) => {
                            setTimeout(() => {
                                swiper.navigation.init();
                                swiper.navigation.update();
                            }, 100);
                        }}
                    >
                        {images.map((image, index) => (
                        <SwiperSlide key={index}>
                            <div className="slide-img">
                            <img src={image} alt="food" />
                            </div>
                        </SwiperSlide>
                        ))}
                    </Swiper>
                )}

                {/* Navigation */}
                <div className="slider-nav">
                    <button ref={prevRef} className="nav-btn">
                    ←
                    </button>
                    <button ref={nextRef} className="nav-btn">
                    →
                    </button>
                </div>
                </div>
            </div>
        </div>

        <div className="wrapper">
        <div className="separator" />
        <div className="quote">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#263A83" ><path d="M4.58341 17.3211C3.55316 16.2274 3 15 3 13.0103C3 9.51086 5.45651 6.37366 9.03059 4.82318L9.92328 6.20079C6.58804 8.00539 5.93618 10.346 5.67564 11.822C6.21263 11.5443 6.91558 11.4466 7.60471 11.5105C9.40908 11.6778 10.8312 13.159 10.8312 15C10.8312 16.933 9.26416 18.5 7.33116 18.5C6.2581 18.5 5.23196 18.0095 4.58341 17.3211ZM14.5834 17.3211C13.5532 16.2274 13 15 13 13.0103C13 9.51086 15.4565 6.37366 19.0306 4.82318L19.9233 6.20079C16.588 8.00539 15.9362 10.346 15.6756 11.822C16.2126 11.5443 16.9156 11.4466 17.6047 11.5105C19.4091 11.6778 20.8312 13.159 20.8312 15C20.8312 16.933 19.2642 18.5 17.3312 18.5C16.2581 18.5 15.232 18.0095 14.5834 17.3211Z"></path></svg>
            <div className="quote-content">
                <h2>Still run by the same family after 43 years—that kind of loyalty, heart, and consistency is hard to find these days. At Main's, it's not just about tradition—it's about staying true to who we are.</h2>
                <p>— Logan Gordon</p>
            </div>
        </div>
        </div>
    </div>

  );
}
